<div class="app-layout">
  <app-header [categories]="categories"></app-header>

  <main class="app-content">
    <router-outlet></router-outlet>
  </main>

  <app-footer></app-footer>
</div>
